import { render, staticRenderFns } from "./orderInformation.vue?vue&type=template&id=27175d36&scoped=true"
import script from "./orderInformation.vue?vue&type=script&lang=js"
export * from "./orderInformation.vue?vue&type=script&lang=js"
import style0 from "./orderInformation.vue?vue&type=style&index=0&id=27175d36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27175d36",
  null
  
)

export default component.exports